module.exports = __webpack_public_path__ + "static/img/not-started.bdf6b962.png";